/*
 *  Blog Template Scripts
 *    Scripts that are only meant to run on the Blog Template.
 *
 *  Version:
 *    1.0.0 - 2020/03/27
 */

import * as ResponsiveSizes from './../settings/Responsive';

// Selectors
export const BLOG_TEMPLATE_CONTAINER = '[data-blog-template]';
export const TAGS_CAROUSEL_SELECTOR = '[data-blog-carousel-tags]';

// Classes
export const CLASS_INITIALIZED = 'slick-initialized';

class BlogTemplate {
  constructor(container) {
    // Elements
    this.container = container;
    this.tagsCarousel = container.find(TAGS_CAROUSEL_SELECTOR);

    this.initTagCarousel();

    // Events
    $(window).on('resize orientationchange', () => this.onResize());

  }

  onResize() {
    if(this.tagsCarousel.hasClass(CLASS_INITIALIZED)) return;
    if($(window).width() > ResponsiveSizes.large) return;
    this.initTagCarousel();
  }

  initTagCarousel() {
    let slick = this.tagsCarousel.slick({
      mobileFirst: true,
      slidesToShow: 3,
      infinite: true,
      dots: false,
      arrows: false,
      focusOnSelect: false,
      centerMode: false,
      draggable: true,
      adaptiveHeight: false,
      swipeToSlide: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: ResponsiveSizes.medium - 1,
          settings: "unslick"
        }
      ]
    });

    return slick;
  }

}

$(document).ready($(BLOG_TEMPLATE_CONTAINER).each((e, i) => new BlogTemplate($(i))));